<div class="error-info" *ngIf="error">
  <span>{{ error }}</span>
</div>

<div
  *ngIf="!organizations.length; else organizationsList"
  class="alc-margin-16 md-headline"
  translate="crm/organizations/no-config"></div>

<ng-template #organizationsList>
  <mat-card *ngFor="let organization of organizations">
    <mat-card-content>
      <div class="organization-header">
        <div>
          <strong translate="crm/organizations/organization-name"></strong>&nbsp;
          <span>{{ organization.name }}</span>
        </div>
        <div class="actions">
          <button
            mat-icon-button
            color="primary"
            [matTooltip]="'crm/organizations/edit-tooltip' | translate"
            (click)="editOrganization(organization.id)">
            <mat-icon>settings</mat-icon>
          </button>
          <button
            mat-icon-button
            color="primary"
            [matTooltip]="'crm/organizations/delete-tooltip' | translate"
            (click)="deleteOrganization(organization)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
      <p>
        <strong translate="crm/organizations/organization-url"></strong>&nbsp;
        <a [href]="organization.instance_url" target="_blank">{{ organization.instance_url }}</a>
      </p>
      <p>
        <mat-slide-toggle
          [(ngModel)]="organization.is_production"
          color="primary"
          aria-label="Define the organization as a production organization"
          disabled>
          <strong translate="crm/organizations/organization-is-production"></strong>
        </mat-slide-toggle>
      </p>
      <p>
        <strong translate="crm/organizations/created-time"></strong>&nbsp;
        <span>{{ organization.created_time | dateTimezone: 'medium' }}</span>
      </p>
      <button
        mat-raised-button
        color="primary"
        translate="authorization/button"
        (click)="reAuthorize(organization)"></button>
    </mat-card-content>
    <hr />
    <mat-card-content>
      <div class="accounts-linked-header" translate="crm/organizations/sites/linked-accounts"></div>
      <div class="account-linked-group">
        <div *ngFor="let linkedSite of organization.linked_sites" class="organization-group-name">
          <ng-container *ngIf="sitesById[linkedSite.site_id] as siteDetails; else accountLinkedWasRemoved">
            <app-site-icon-and-name [item]="siteDetails" class="alc-ellipsis">{{
              siteDetails?.name
            }}</app-site-icon-and-name>
          </ng-container>

          <ng-template #accountLinkedWasRemoved>
            <mat-icon class="account-linked-error-icon" color="warn">error</mat-icon>
            <span
              translate="crm/organizations/sites/linked-account-not-exists"
              [translateParams]="{ siteId: linkedSite.site_id }"></span>
          </ng-template>

          <div class="actions">
            <mat-slide-toggle
              [disabled]="!sitesById[linkedSite.site_id]"
              [(ngModel)]="linkedSite.is_active"
              (ngModelChange)="updateLinkedSite(organization.id, linkedSite)"
              color="primary"
              aria-label="enable or disable the connection"
              [matTooltip]="
                'crm/organizations/sites/' + (linkedSite.is_active ? 'disable' : 'enable') + '-tooltip' | translate
              ">
            </mat-slide-toggle>

            <button
              mat-icon-button
              [color]="sitesById[linkedSite.site_id] ? 'primary' : 'warn'"
              (click)="deleteLinkedSite(organization, linkedSite)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>
      <button
        mat-button
        color="primary"
        [disabled]="sitesService.sitesV2?.length === alreadyLinkedSitesIdsByOrgId[organization.id]?.size"
        (click)="chooseSiteToLink(organization)"
        aria-label="link account"
        translate="crm/organizations/sites/link-account"></button>
    </mat-card-content>
  </mat-card>
</ng-template>

<!-- Template used when trying to connect a new CRM organization -->
<ng-template #connectCrmOrganizationTemplateRef>
  <mat-form-field class="w-100">
    <mat-label translate="crm/organizations/login-url"></mat-label>
    <input type="text" matInput [formControl]="loginUrlControl" />
  </mat-form-field>
</ng-template>

<!-- Template used when trying to link a new account to the organization -->
<ng-template #chooseSiteToLinkTemplateRef>
  <app-select
    [control]="siteSelectedControl"
    [items]="availableSitesToLinkForOrgId"
    [optionTemplateName]="'site-icon'"
    [enableTypeahead]="true"
    [labelKey]="'account'">
  </app-select>
</ng-template>
